import { atomFamily } from 'recoil';

import { iaRa } from 'lib/helpers/utility';

import { persistPerWorkspace } from 'components/GlobalDock/lib/dockWorkspace';

const OPEN_CHARTS_STORAGE_KEY = 'myriad:open-charts';

export const MAX_RECENT_CHARTS = 8;

// `practice_id` is set on charts an admin opened in a practice, whose address names the practice.
const CHART_FIELDS = ['id', 'f_name', 'l_name', 'p_name', 'profile_photo', 'practice_id'];

export const sanitizeChart = (chart) =>
  chart && typeof chart.id === 'number'
    ? Object.fromEntries(CHART_FIELDS.map((field) => [field, chart[field] ?? null]))
    : null;

const sanitize = (value) => {
  const charts = Object.fromEntries(
    Object.values(value?.charts || {})
      .map(sanitizeChart)
      .filter(Boolean)
      .map((chart) => [chart.id, chart])
  );
  const recent = iaRa(value?.recent)
    .filter((id) => typeof id === 'number' && !!charts[id])
    .slice(0, MAX_RECENT_CHARTS);

  return { recent, charts };
};

/**
 * The charts opened in this session, per dock workspace (a practice, or the admin portal): each
 * patient's identity, which the dock's chart tabs show, and `recent`, which feeds "Recent charts" in
 * the Open tabs panel.
 */
export const openChartsState = atomFamily({
  key: 'openChartsState',
  default: { recent: [], charts: {} },
  effects: persistPerWorkspace({ storageKey: OPEN_CHARTS_STORAGE_KEY, sanitize })
});
